// extracted by mini-css-extract-plugin
module.exports = {"operation-name":"operation-name_operation-name__wSvBe"};